import { render, staticRenderFns } from "./EddmProcess.vue?vue&type=template&id=36d1cb2e"
import script from "./EddmProcess.vue?vue&type=script&lang=js"
export * from "./EddmProcess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports